import { NgModule } from '@angular/core';
import { ImagingFilesComponent } from '../components/ehr/patients/components/imaging-section/imaging-files/imaging-files.component';
import { LaboratoryFileComponent } from '../components/ehr/patients/components/laboratory-section/laboratory-file/laboratory-file.component';
import { SupportingDocumentsComponent } from '../components/ehr/patients/components/inital-assessment-amen-section/supporting-documents/supporting-documents.component';
import { HysteroscopyFileComponent } from '../components/ehr/patients/components/hysteroscopy-section/hysteroscopy-file/hysteroscopy-file.component';
import { ReusableTableComponent } from '../common/reusable-table/reusable-table.component';
import { ReusableReverseTableComponent } from '../common/reusable-reverse-table/reusable-reverse-table.component';
import { ReusableDynamicTableComponent } from '../common/reusable-dynamic-table/reusable-dynamic-table.component';
import { MultipleSclerosisSegmentationComponent } from '../components/ehr/patients/components/imaging-section/multiple-sclerosis-segmentation/multiple-sclerosis-segmentation.component';
import { CustomTableComponent } from '../components/ehr/workspace/my-patients/custom-table/custom-table.component';
import { OurImageCropperComponent } from '../components/ehr/register-patient/our-image-cropper/our-image-cropper.component';
import { TooltipComponent } from '../common/tooltip/tooltip.component';
import { SharedModule } from './shared.module';
import { CarePlanFileComponent } from '../components/ehr/patients/components/health-care-plan-section/care-plan-file/care-plan-file.component';
import { PreciousMedSamSegmentationComponentComponent } from '../components/ehr/patients/components/imaging-section/precious-med-sam-segmentation-component/precious-med-sam-segmentation-component.component';

@NgModule({
  imports: [
    SharedModule,
    ImagingFilesComponent,
    LaboratoryFileComponent,
    CarePlanFileComponent,
    SupportingDocumentsComponent,
    HysteroscopyFileComponent,
    ReusableTableComponent,
    ReusableReverseTableComponent,
    ReusableDynamicTableComponent,
    MultipleSclerosisSegmentationComponent,
    PreciousMedSamSegmentationComponentComponent,
    CustomTableComponent,
    TooltipComponent,
    OurImageCropperComponent,
  ],
  exports: [
    ImagingFilesComponent,
    LaboratoryFileComponent,
    CarePlanFileComponent,
    SupportingDocumentsComponent,
    HysteroscopyFileComponent,
    ReusableTableComponent,
    ReusableReverseTableComponent,
    ReusableDynamicTableComponent,
    MultipleSclerosisSegmentationComponent,
    PreciousMedSamSegmentationComponentComponent,
    CustomTableComponent,
    TooltipComponent,
    OurImageCropperComponent,
  ],
})
export class StandaloneModule {}
